<template>
    <div class="personal-certificate" v-loading="loading">
        <module-title title="我的证书"></module-title>
        <div class="cer_list_box course_news_box ">
            <el-tabs v-model="valid">
                <el-tab-pane label="我的岗位证书" name="0"></el-tab-pane>
            </el-tabs>
            <el-button @click="visible=true" style="background: #b21f27;border: 0;color:#fff;margin-bottom:20px;" size="medium">添加证书</el-button>
            <!-- 证书列表 -->
            <div class="cer_list">
                <!-- 暂无证书发放 -->
                <p class="noMessage" v-if="noMessage">暂无证书</p>
                <personal-cerficate v-if="!noMessage">
                    <personal-cerficate-item v-for="cerItem in cerList" :key="cerItem.id" :cerItem="cerItem">
                        <div class="cer_item_news_text" slot="postNameLabel">{{cerItem.postNameLabel}}</div>
                        <div class="cer_item_news_text" slot="certCode">{{cerItem.certCode}}</div>
                        <div class="cer_item_news_text" slot="issuingUnit">{{cerItem.issuingUnit}}</div>
                        <div class="cer_item_news_text" slot="effectiveDate">{{cerItem.effectiveDate}}</div>
                    </personal-cerficate-item>
                </personal-cerficate>
                <!-- 分页器 -->
                <div class="block page_box mtop20">
                    <el-pagination
                        v-if="!noMessage"
                        layout="prev, pager, next"
                        :page-size="page.size"
                        :background="true"
                        :total="page.total"
                        @current-change="handleCurrentChange"
                    >
                    </el-pagination>
                </div>
            </div>
         </div>
        <!-- 添加证书 -->
         <el-dialog
            title="添加证书"
            :visible.sync="visible"
            :before-close="handleClose"
            center>
            <el-form ref="form" :model="form" label-width="120px" :rules="rules">
                <el-form-item label="岗位名称" prop="postName">
                    <el-select
                        v-model="form.postName"
                        placeholder="请选择岗位"
                        style="width: 100%"
                        :disabled="disabled"
                    >
                        <el-option
                            v-for="item in postNameOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="证书编号" prop="certCode">
                    <el-input
                        v-model="form.certCode"
                        :disabled="disabled"
                        placeholder="请输入岗位证书编号"
                    ></el-input>
                    <div class="input-description">说明：请认真检查输入或复制的内容是否正确，不要有空格、全角字符或其他字符存在。</div>
                </el-form-item>
                <el-form-item label="岗位名称" prop="postName1">
                    <el-select
                        v-model="form.postName1"
                        placeholder="请选择岗位"
                        style="width: 100%"
                        :disabled="disabled"
                    >
                        <el-option
                            v-for="item in postNameOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="证书编号" prop="certCode1">
                    <el-input
                        v-model="form.certCode1"
                        :disabled="disabled"
                        placeholder="请输入岗位证书编号"
                    ></el-input>
                    <div class="input-description">说明：请认真检查输入或复制的内容是否正确，不要有空格、全角字符或其他字符存在。</div>
                </el-form-item>
                <el-form-item label="发证单位" prop="issuingUnit">
                    <el-input
                        v-model="form.issuingUnit"
                        :disabled="disabled"
                        placeholder="请输入发证单位"
                    ></el-input>
                </el-form-item>
                <el-form-item label="发证日期"  prop="issuingDate">
                    <el-date-picker
                        style="width:100%"
                        v-model="form.issuingDate"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="有效期至"  prop="effectiveDate">
                    <el-date-picker
                        style="width:100%"
                        v-model="form.effectiveDate"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="证书状态" prop="certStatus">
                    <el-select
                        v-model="form.certStatus"
                        placeholder="请选择证书状态"
                        style="width: 100%"
                        :disabled="disabled"
                    >
                        <el-option
                            v-for="item in certOPtions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="继续教育记录" prop="eduRecord">
                    <el-input
                        v-model="form.eduRecord"
                        :disabled="disabled"
                        placeholder="请输入继续教育记录"
                    ></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remarks">
                    <el-input
                        v-model="form.remarks"
                        :disabled="disabled"
                        placeholder="请输入备注"
                        type="textarea"
                        :rows="2"
                    ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel('form')">取 消</el-button>
                <el-button type="primary" @click="submit('form')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import ModuleTitle from "@/components/common/moduleTitle/ModuleTitle";
import PersonalCerficate from "@/components/contents/personalCerficate/PersonalCerficate";
import PersonalCerficateItem from "@/components/contents/personalCerficate/PersonalCerficateItem";
import { PcCookie, Key } from "@/utils/cookie";
import { getCertIssueLis, addCer } from "api/personal"
import { getDictValues  } from "@/api/register";
import VueEvent from '@/VueEvent.js'
export default {
    components:{ ModuleTitle,PersonalCerficate, PersonalCerficateItem },
    computed:{
        noMessage() {
            return this.page.total == 0 ? true : false;
        },
    },
    data(){
        var validatePostName = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请岗位名称"));
            } else if (value !== this.form.postName) {
                callback(new Error("两次选择的岗位名称不一致！"));
            } else {
                callback();
            }
        };
        var validateCertCode = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入证书编号"));
            } else if (value !== this.form.certCode) {
                callback(new Error("两次输入的证书编号不一致！"));
            } else {
                callback();
            }
        };

        return{
            loading:false,
            sessionId:PcCookie.get(Key.jsessIdKey),
            valid:'0', //0 有效期内  1 过期
            page: {
                current: 1,
                size: 10,
                total: 0,
            },
            cerList:[],
            postNameOptions:[],
            certOPtions:[],
            form:{
                postName:"",
                certCode:"",
                postName1:"",
                certCode1:"",
                issuingUnit:"",
                issuingDate:"",
                effectiveDate:"",
                certStatus:"",
                eduRecord:"",
                remarks:""
            },
            rules: {
                postName: [
                    {
                        required: true,
                        message: "请选择岗位名称",
                        trigger: "blur",
                    },
                ],
                certCode: [
                    {
                        required: true,
                        message: "请输入证书编号",
                        trigger: "blur",
                    },
                ],
                postName1: [
                    {
                        required: true,
                        validator: validatePostName,
                        trigger: "change",
                    },
                ],
                certCode1: [
                    {
                        required: true,
                        validator: validateCertCode,
                        trigger: "blur",
                    },
                ],
                issuingUnit: [
                    {
                        required: true,
                        message: "请输入发证单位",
                        trigger: "blur",
                    },
                ],
                issuingDate: [
                    {
                        required: true,
                        message: "请选择发证日期",
                        trigger: "blur",
                    },
                ],
                effectiveDate: [
                    {
                        required: true,
                        message: "请选择有效期",
                        trigger: "blur",
                    },
                ],
                certStatus: [
                    {
                        required: true,
                        message: "请选择证书状态",
                        trigger: "blur",
                    },
                ],
                eduRecord: [
                    {
                        required: true,
                        message: "请输入继续教育记录",
                        trigger: "blur",
                    },
                ],
            },
            disabled:false,
            visible:false,
        }
    },
    mounted() {
        VueEvent.$on("refreshCerTable", () => {
            this.refreshTable();
        });

    },
    async created(){
        this.loading = true;
        await this.fetchCertIssueLis();
        await this.fetchValues("post_name_opts",this.postNameOptions);
        await this.fetchValues("cert_status_opts",this.certOPtions);
        this.loading = false;
    },
    methods:{
        submit(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.disabled = true;
                    addCer(this.sessionId,this.form).then((res) => {
                        if (res.errorCode === "2000") {
                            this.$message({
                                message: "添加成功",
                                type: "success",
                            });
                            this.cancel('form');
                            this.fetchCertIssueLis();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: "error",
                            });
                        }
                        this.disabled = false;
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleClose(){
            this.visible = false;
        },
        cancel(formName){
            this.$refs[formName].resetFields();
            this.visible = false;
        },
        refreshTable(){
            this.page.current = 1;
            this.fetchCertIssueLis();
        },
        handleCurrentChange(val){
            this.page.current = val;
            this.fetchCertIssueLis();
        },
        //获取证书列表
        fetchCertIssueLis(){
            getCertIssueLis(this.sessionId,this.valid,this.page.current,
                this.page.size).then(res => {
                if (res.errorCode === "2000") {
                    this.cerList = res.body.data.rows;
                    this.page.total = res.body.data.total;
                }
            })
        },
        //查询岗位名称分类
        fetchValues(type,list) {
            getDictValues(type).then((res) => {
                const { body, success } = res;
                if (success) {
                    list.splice(0, list.length, ...body.data);
                }
            });
        },
    }
}
</script>
<style scoped>
.noMessage {
    height: 120px;
    line-height: 120px;
    font-size: 16px;
    color: #818181;
    text-align: center;
}
</style>
